export default "__VITE_ASSET__B0wb0TdG__"